import { z } from "zod";
import { TObjectBase } from "../base";
import {
  TRawBooleanInfoFieldValue,
  TRawNumberInfoFieldValue,
  TRawStringInfoFieldValue,
  TRawStringArrayInfoFieldValue,
  TRawArrayInfoFieldValue,
} from "../infoField";
import {
  TApiUnitFinanceInfoFields,
  TInfoField,
  TRawUnitLandlordAdminInfoFields,
  TRawUnitNoteInfoFields,
} from "./fields/infoField";
import { TVisibilitySource } from "./unit.visibility";
import { TRelatives } from "../common/relative";

export enum UnitType {
  other = 0,
  apartments = 1,
  office = 2,
  restaurant = 3,
  storage = 4,
  car = 5,
  outsideArea = 6,
  store = 7,
  production = 8,
  healthServices = 9,
  gym = 10,
  hairSalon = 11,
  workshop = 12,
  parking = 13,
}

export type IUnitType = z.infer<typeof TUnitType>;
export const TUnitType = z.nativeEnum(UnitType);

/* @deprecated Use the new IRawUnit type */
export type IUnit = z.infer<typeof TUnit>;
/* @deprecated Use the new TRawUnit schama */
export const TUnit = z
  .object({
    infoFields: z.optional(z.record(z.optional(TInfoField))),
    name: z.string(),
  })
  .extend(TObjectBase.shape);

export type IRawUnitFields = z.infer<typeof TRawUnitFields>;
export const TRawUnitFields = z
  .object({
    apartmentNumber: TRawStringInfoFieldValue,
    area: TRawNumberInfoFieldValue,
    bedroomCount: TRawNumberInfoFieldValue,
    contactEmail: TRawStringInfoFieldValue,
    contactInformation: TRawStringInfoFieldValue,
    contactPhone: TRawStringInfoFieldValue,
    fireSafetyResponsibles: TRawStringArrayInfoFieldValue,
    floors: TRawArrayInfoFieldValue, // can be either a number[] or string[]
    furnished: TRawBooleanInfoFieldValue,
    orgNumber: TRawStringInfoFieldValue,
    parkingSpots: TRawNumberInfoFieldValue,
    postAddress: TRawStringInfoFieldValue,
    snr: TRawStringInfoFieldValue,
    streetNumber: TRawStringInfoFieldValue,
    tenantType: TRawStringInfoFieldValue,
    type: TRawNumberInfoFieldValue,
  })
  .partial();

export type IRawUnit = z.infer<typeof TRawUnit>;
export const TRawUnit = z
  .object({
    name: z.string(),
    fields: TRawUnitFields.optional(),
    visibility: z.array(TVisibilitySource).optional(),
    relatives: TRelatives.nullish(),
  })
  .extend(TObjectBase.shape);

export type IApiUnit = z.infer<typeof TApiUnit>;
export const TApiUnit = z.object({
  id: z.string(),
  propertyID: z.string(),
  name: z.string(),
  archived: z.boolean().optional(), // TODO - remove optional when web-app is updated
  fields: TRawUnitFields.extend(TApiUnitFinanceInfoFields.shape)
    .extend(TRawUnitLandlordAdminInfoFields.shape)
    .extend(TRawUnitNoteInfoFields.shape)
    .partial()
    .optional(),
});
